// NOTE: NSAI-3499 — React Query key and page size for the owner's "Shared chats"
// list. Shared so a revoke on either client invalidates the same cache entry.
export const OWNED_SHARED_CHATS_QUERY_KEY = "owned-shared-chats";
export const OWNED_SHARED_CHATS_PAGE_SIZE = 20;
